import { HTTPClient } from "../common/HTTPClient";
import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface ErrorNotificationQueryParams {
  search?: string;
  fromDate?: string | Date;
  toDate?: string | Date;
}
export interface Queryform {
  search?: string;
  id?: string;
}

export class NotificationClient {
  constructor(private httpClient: HTTPClient) {}

  public async getErrorNotification(
    param: ErrorNotificationQueryParams,
    paginatedValue: PaginationRequestParams
  ): Promise<any> {
    let queryParam = "?search=";
    if (param.search && param.fromDate && param.toDate) {
      queryParam += `${param.search}&fromDate=${param.fromDate}&toDate=${param.toDate}`;
    } else if (param.search) {
      queryParam += param.search;
    } else if (param.fromDate && param.toDate) {
      queryParam += `&fromDate=${param.fromDate}&toDate=${param.toDate}`;
    } else {
      queryParam = "";
    }

    const { data } = await this.httpClient.request({
      url: `error-notifications${queryParam}`,
      method: "GET",
      params: paginatedValue
    });

    return data;
  }

  public async updateAcknowledgementById(id: number) {
    const { data } = await this.httpClient.request({
      url: `error-notifications/acknowledgement/${id}`,
      method: "PATCH",
      data: {
        acknowledgement: true
      }
    });

    return data;
  }

  public async getOneError(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `error-events/${id}`,
      method: "GET"
    });

    return data;
  }

  public async getErrorEvent(
    query: Queryform,
    paginatedValue: PaginationRequestParams
  ): Promise<any> {
    let getErrorById = "&notificationId=";
    if (query.id) {
      getErrorById += query.id;
    } else {
      getErrorById = "";
    }
    const { data } = await this.httpClient.request({
      url: `error-events?search=${query.search}${getErrorById}`,
      method: "GET",
      params: paginatedValue
    });

    return data;
  }
}
